import { render, staticRenderFns } from "./ImageVideoTab.vue?vue&type=template&id=4c4087f1&scoped=true"
import script from "./ImageVideoTab.vue?vue&type=script&lang=js"
export * from "./ImageVideoTab.vue?vue&type=script&lang=js"
import style0 from "./ImageVideoTab.vue?vue&type=style&index=0&id=4c4087f1&prod&lang=css"
import style1 from "./ImageVideoTab.vue?vue&type=style&index=1&id=4c4087f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4087f1",
  null
  
)

export default component.exports